module.exports = __webpack_public_path__ + "media/story_video.b850e5f8.mp4";